import type { DisplayStrategyCallback } from '.';
import type { SnackBarState } from '..';

export function create(state: SnackBarState): DisplayStrategyCallback {
  return () => {
    return Promise.resolve(!state.closed);
  };
}
